import { render } from "./ClosedAccounting.vue?vue&type=template&id=38ebf594"
import script from "./ClosedAccounting.vue?vue&type=script&lang=js"
export * from "./ClosedAccounting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__